import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { PourQui } from "./components/PourQui";
import { Cours } from "./components/Cours";
import { Mariage } from "./components/Mariage";
import { APropos } from "./components/APropos";
import { Videos } from "./components/Videos";
import { Avis } from "./components/Avis";
import { Tarifs } from "./components/Tarifs";
import { FAQ } from "./components/FAQ";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { Chatbot } from "./components/Chatbot";
import { PromoBanner } from "./components/PromoBanner";
import { StructuredData } from "./components/StructuredData";

import MentionsLegales from "./pages/MentionsLegales";
import PolitiqueConfidentialite from "./pages/PolitiqueConfidentialite";
import ConditionsGenerales from "./pages/ConditionsGenerales";
import NotFound from "./pages/NotFound";

const Home = () => {
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 80);
      }
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("visible");
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <StructuredData />
      <Header />
      <main>
        <Hero />
        <Mariage />
        <APropos />
        <Videos />
        <Avis />
        <Tarifs />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <Chatbot />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#1A2A40",
            color: "#F7F3EA",
            border: "1px solid rgba(201,168,105,0.35)",
            borderRadius: 0,
            fontFamily: "Montserrat, sans-serif",
          },
        }}
      />
      <BrowserRouter>
        <PromoBanner />
        <Routes>
          <Route path="/" element={<Home />} />
          {/* Pages légales — URLs canoniques */}
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/confidentialite" element={<PolitiqueConfidentialite />} />
          <Route path="/conditions-generales" element={<ConditionsGenerales />} />
          {/* Redirections des anciennes URLs (compatibilité SEO) */}
          <Route path="/politique-confidentialite" element={<Navigate to="/confidentialite" replace />} />
          <Route path="/conditions-reservation" element={<Navigate to="/conditions-generales" replace />} />
          {/* 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
